import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LinkWithIconCheckOnMap, Loader } from '@dataplace.ai/ui-components/atoms'
import { useSelector } from 'react-redux'
import { RootState } from 'apps/placeme/src/redux/store'
import { ITileData } from 'apps/placeme/src/features/Analyse/slice/@types/ITileData'
import { LocationStatusResponseKeys } from '@dataplace.ai/ui-components/atoms/KanbanMap/utils/constants'
import {
  CompetitorsNumber, Section, SectionMainText,
  SectionTitle, StyledTitleFormSectionSubTitle, Wrapper,
} from './WellFitCompetitionWithinRange.styles'
import useWellFitCompetitionWithinRange from './hooks/useWellFitCompetitionWithinRange'
import WellFitCompetitionMap from './components/WellFitCompetitionMap'

interface SharedLocationProps {
  brand: string
  address: string
  lat: number
  lng: number
  distance: number
}

interface OwnLocation extends SharedLocationProps {
  status: LocationStatusResponseKeys
  siteId?: string
  name?: string
}
interface CompetitorLocation extends SharedLocationProps {
  logo?: string
}

interface WellFitCompetitionData {
  competition: {
    own: OwnLocation[]
    competitors: CompetitorLocation[]
  }
}

export interface WellFitCompetitionWithinRangeProps extends ITileData {
  value: WellFitCompetitionData
}

export const WellFitCompetitionWithinRange: React.FC<{
  data: WellFitCompetitionWithinRangeProps,
  tileId: string
}> = ({
  data,
  tileId,
}) => {
  const { t } = useTranslation()
  const { value: analysedLocation } = useSelector((state: RootState) => state.location)
  const { values } = useSelector((state: RootState) => state.analysis)
  const [isMapModalDisplayed, setIsMapModalDisplayed] = useState(false)
  const handleMapOpen = () => setIsMapModalDisplayed(!isMapModalDisplayed)

  const {
    own,
    competitors,
    layers,
    catchmentId,
  } = useWellFitCompetitionWithinRange({
    values,
    tileId,
    data,
  })

  if (!data?.value || data.loading) return <Loader />

  return (
    <Wrapper>
      <Section>
        <SectionTitle>
          {t('placeme.well_fit_competition_within_range.section_title_1')}
        </SectionTitle>
        <SectionMainText>
          {t('placeme.well_fit_competition_within_range.own_points_in_range')}
          {' '}
          <CompetitorsNumber>{own?.length ?? 0}</CompetitorsNumber>
        </SectionMainText>
        <SectionMainText>
          {t('placeme.well_fit_competition_within_range.competition_points_in_range')}
          {' '}
          <CompetitorsNumber>{competitors?.length ?? 0}</CompetitorsNumber>
        </SectionMainText>
        <StyledTitleFormSectionSubTitle>
          <span>{t('placeme.pois_tile.points_on_map')}</span>
          <LinkWithIconCheckOnMap onClick={() => handleMapOpen()} />
        </StyledTitleFormSectionSubTitle>
        <WellFitCompetitionMap
          analysedLocation={analysedLocation}
          catchmentId={catchmentId}
          isMapModalDisplayed={isMapModalDisplayed}
          layers={layers}
          mapLocation={{
            zoom: 14,
            center: {
              lat: analysedLocation?.lat || 0,
              lng: analysedLocation?.lng || 0,
            },
          }}
          setIsMapModalDisplayed={setIsMapModalDisplayed}
        />
      </Section>
    </Wrapper>
  )
}

